import "./guide.css"
import logo from "../Assets/logo.webp"
import credible from "../Assets/guide/profile.webp"
export const GuideHeader = () => {
  return (
    <>  
      <div className="py-4">
        <div className="row">
          <div className="col">
            <img src={logo} className="img-fluid logo" alt="wef-3-logo" />
          </div>
          <div className="col d-flex justify-content-end align-items-center">
            <img src={credible} className="img-fluid credible" alt="niec-credible" />
          </div>
        </div>
      </div>
    </>
  )
}